<template>
	<Route
		:loading="loading"
		:routes="routes"
		:breadcrumbs="breadcrumbs"
		:route-title="project.name"
	>
		<template slot="title">
			{{ project.name }}
			<span
				v-if="project.isArchived"
				class="route-archive-text"
			>
				(Archived)
			</span>
		</template>
		<transition
			:name="transition"
			mode="out-in"
		>
			<keep-alive>
				<router-view />
			</keep-alive>
		</transition>
	</Route>
</template>

<script>
import Route from '@/views/layouts/Route';

export default {
	components: {
		Route,
	},
	data() {
		return {
			transition: '',
			loading: true,
		};
	},
	created() {
		const projectId = parseInt(this.$route.params.projectId);

		// Load current project and related data
		this.$store.dispatch('projects/loadCurrentProjectAndRelatedData', projectId).then((resp) => {
			dump('project/Index.vue', 'Current project and related data loaded', resp);
		}).catch((e) => {
			dump('Error loading current project and related data', e);
			this.$notify('error', 'Failed to retrieve project or related data.');
			this.$router.push({ name: 'Error' });
		}).finally(() => {
			this.loading = false;
		});
	},
	computed: {
		project() {
			return this.$store.get('projects/currentProject');
		},
		breadcrumbs() {
			const isSingleProject = this.$store.get('projects/isSingleProject');

			return [
				{ text: 'Dashboard', to: '/' },
				...(isSingleProject ? [] : [{ text: 'Projects', to: '/projects', exact: true }]),
				{ text: this.project.name, disabled: true },
			];
		},
		routes() {
			const manageProjects = this.project.userCan('manage_projects');
			const manageUsers = this.project.userCan('manage_users');
			const manageCustomData = this.project.userCan('view_custom_data');
			const hasKeywordsSkill = this.$store.get('isSkilled', 'keywords');

			return [
				{ name: 'Reports', to: { name: 'ReportsList' } },
				{ name: 'Categories', to: { name: 'Categories' } },
				...(hasKeywordsSkill ? [{ name: 'Keywords', to: { name: 'Keywords' } }] : []),
				...(manageUsers ? [{ name: 'Users', to: { name: 'Users' } }] : []),
				{ name: 'Outputs', to: { name: 'ReportOutput' } },
				...(manageCustomData ? [{ name: 'Custom Data', to: { name: 'CustomData' } }] : []),
				...(this.$store.get('superUser') ? [{ name: 'Overrides', to: { name: 'Overrides' } }] : []),
				...(manageProjects ? [{ name: 'Settings', to: { name: 'ProjectSettings' } }] : []),
			];
		},
	},
	/** @todo Duplicated in few places, find a way to DRY it out */
	beforeRouteUpdate(to, from, next) {
		const fromIndex = this.routes.findIndex(r => r.to.name === from.name);
		const toIndex = this.routes.findIndex(r => r.to.name === to.name);

		if (fromIndex === toIndex) {
			this.transition = '';
		}
		else if (fromIndex < toIndex) {
			this.transition = 'slide-left';
		}
		else {
			this.transition = 'slide-right';
		}

		next();
	},
};
</script>
